<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<template>
  <section class="disclaimer-container">
    <LoadingIndicator :showLoading="loading" />

    <div class="disclaimer-inner-container">
      <div class="logo-wrapper">
            <!-- Show skeleton only during logo loading -->
            <!-- <template v-if="tenantLogoGuid && tenantLogoLoading"> -->
              <div class="skeleton skeleton-logo" v-if="tenantLogoGuidComputed && tenantLogoLoadingComputed"></div>
            <!-- </template> -->

            <!-- Show logo when available -->
            <!-- <template v-else-if="tenantLogoGuid && tenantLogoLoaded"> -->
              <img
                :src="logoPath + tenantLogoGuidComputed"
                @load = "handleImageLoad"
                @error="handleImageError"
                alt="Tenant Logo"
                class="tenant-logo-img"
                :class="{ 'is-loaded': tenantLogoLoadedComputed }"
                v-if="tenantLogoGuidComputed"
              />
            <!-- </template> -->

            <!-- Fallback: show tenant name if logo is missing after load -->
            <!-- <template v-else> -->
              <div class="tenant-name-fallback" v-if="!tenantLogoGuidComputed || (!tenantLogoLoadingComputed &&!tenantLogoLoadedComputed)">
                {{ tenantInfo?.name || tenantInfo?.identifier || "" }}
              </div>
            <!-- </template> -->
          </div>
      <!-- Step 1 -->
      <div
        v-show="step !== 3"
        :class="['card-base', 'disclaimer-card', { blurred: step === 2 }]"
      >
        <div class="header">


          <div class="header-text">
            <!-- Display the appropriate title:
            - If 'title' param exists: use it
            - Else if standalone tenant and property enabled: use job 'disclaimerJobTitle' from ShortUrl, else display default Whatsapp text
            - Else if AI disclaimer: use aiDefaultText
            - Else (ATS tenant): use whatsAppDefaultText -->
            <!-- <template v-if="showTitleBlock"> -->
              <p class="layout-subtitle">
                {{ getDisplayText("message.applicationSubtitle") }}
              </p>
              <h2 class="layout-title">{{ displayTitle }}</h2>
            <!-- </template> -->
            <!-- <template v-else>
              <div class="skeleton skeleton-subtitle layout-subtitle"></div>
              <div class="skeleton skeleton-title layout-title"></div>
            </template> -->
          </div>
        </div>
        <div class="steps">
          <!-- Info Text 1 -->
          <div class="step-item">
            <div class="icon-stack">
              <div class="icon-box">
                <img src="@/assets/Arrow_Circle.svg" alt="Bullseye" />
              </div>
              <div class="vertical-line"></div>
            </div>
            <div class="step-text">
              <h3>{{ getDisplayText("message.step1Title") }}</h3>
              <p>{{ getDisplayText("message.step1Desc") }}</p>
            </div>
          </div>

          <!-- Info Text 2 -->
          <div class="step-item">
            <div class="icon-stack">
              <div class="icon-box">
                <img src="@/assets/Check_Circle.svg" alt="Check" />
              </div>
              <div class="vertical-line"></div>
            </div>
            <div class="step-text">
              <h3>{{ getDisplayText("message.step2Title") }}</h3>
              <p>{{ getDisplayText("message.step2Desc") }}</p>
            </div>
          </div>

          <!-- Info Text 3 -->
          <div class="step-item">
            <div class="icon-stack">
              <div class="icon-box">
                <img src="@/assets/Phone_Circle.svg" alt="Phone" />
              </div>
              <div class="vertical-line"></div>
            </div>
            <div class="step-text">
              <h3>{{ getDisplayText("message.step3Title") }}</h3>
              <p>{{ getDisplayText("message.step3Desc") }}</p>
            </div>
          </div>

          <!-- Info Text 4 (no vertical-line for last one) -->
          <div class="step-item">
            <div class="icon-stack">
              <div class="icon-box">
                <img src="@/assets/Plane_Circle.svg" alt="Send" />
              </div>
            </div>
            <div class="step-text">
              <h3>{{ getDisplayText("message.step4Title") }}</h3>
              <p>{{ getDisplayText("message.step4Desc") }}</p>
            </div>
          </div>
        </div>
        <!-- Button -->
        <div class="button-footer-group">
          <template v-if="primaryColor">
            <button
              class="primary-btn"
              @click="handleRedirectToDisclaimer"
              :style="
                resolvedPrimaryColor
                  ? { backgroundColor: resolvedPrimaryColor }
                  : undefined
              "
            >
              <font-awesome-icon
                :icon="faWhatsapp"
                width="24"
                height="24"
                style="color: #ffffff"
              />
              {{ getDisplayText("message.applyBtn") }}
            </button>
          </template>
          <template v-else>
            <div class="skeleton skeleton-button"></div>
          </template>
        </div>
      </div>

      <div v-show="step === 2" class="consent-overlay">
        <div class="consent-card">
          <template v-if="showDisclaimerText">
            <div class="consent-header">
              {{ t("message.consentHeader")
              }}<button class="close-btn" @click="closeConsentCard">
                &times;
              </button>
            </div>
            <div class="consent-body">
              <div class="disclaimer-text">
                <span
                  v-for="(part, index) in combinedDataPrivacyText"
                  :key="index"
                >
                  <template v-if="isPlaceholder(part)">
                    <template v-if="part === '{newLine}'">
                      <br />
                    </template>
                    <template v-else>
                      <a
                        :href="getPlaceholderLink(part)"
                        target="_blank"
                        class="link"
                      >
                        {{ getPlaceholderLabel(part) }}
                      </a>
                    </template>
                  </template>
                  <template v-else>{{ part }}</template>
                </span>
              </div>
            </div>
            <!-- Agree button -->
            <button
              class="primary-btn mt-16"
              @click="onAgreeDisclaimer"
              :style="{ backgroundColor: primaryColor }"
            >
              {{ t("message.agreeBtn") }}
            </button>
          </template>
          <template v-else>
            <div class="skeleton skeleton-disclaimer-block"></div>
          </template>
        </div>
      </div>

      <!-- Step 3: QR Code Display -->
      <div v-show="step === 3" class="card-base success-card">
        <div class="header">
          <!-- <div class="logo-wrapper">
            <div class="skeleton skeleton-logo" v-if="tenantLogoGuid && tenantLogoLoading"></div>
            <img
                :src="logoPath + tenantLogoGuid"
                @load = "handleImageLoad"
                @error="handleImageError"
                alt="Tenant Logo"
                class="tenant-logo-img"
                :class="{ 'is-loaded': tenantLogoLoaded }"
                v-if="tenantLogoGuid"
              />
              <div class="tenant-name-fallback" v-if="!tenantLogoGuid &&!tenantLogoLoaded">
                {{ tenantInfo?.name || tenantInfo?.identifier || "" }}
              </div>
             <template v-if="tenantLogoGuid && !tenantLogoLoaded">
              <div class="skeleton skeleton-logo"></div>
            </template>
            <template v-else-if="tenantLogoGuid && tenantLogoLoaded">
              <img
                :src="logoPath + tenantLogoGuid"
                @load="onTenantLogoLoaded"
                @error="onTenantLogoError"
                alt="Tenant Logo"
              />
            </template>
            <template v-else>
              <div class="tenant-name-fallback">
                {{ tenantInfo?.name || tenantInfo?.identifier || "" }}
              </div>
            </template>
          </div> -->
          <div class="header-text">
            <h2 class="layout-title">{{ t("message.successTitle") }}</h2>
          </div>
        </div>

        <div class="description">
          {{ getDisplayText("message.successDesc_1") }}<br />
          {{ getDisplayText("message.successDesc_2") }}<br />
          {{ getDisplayText("message.successDesc_3") }}
        </div>
        <!-- 
        <div class="qr-instruction">{{ t('message.qrCodeInstruction') }}</div> -->

        <!-- QR Code with loading overlay (Step 3) -->
        <div class="qr-wrapper">
          <div class="qr-box">
            <QrCodeComp
              :value="qrCodeLink"
              :logoUrl="logoPath + tenantLogoGuid"
              :width="300"
              :height="300"
              :showLogo="false"
              @qr-ready="onQrCodeReady"
            />
            <div
              v-if="!qrImageLoaded"
              class="skeleton skeleton-qr-overlay"
            ></div>
          </div>
        </div>
        

        <button
          class="primary-btn"
          @click="handleRedirectFromBtn"
          :style="{ backgroundColor: primaryColor }"
        >
          {{ t("message.openDesktopBtn") }}
        </button>
      </div>
    </div>

    <!-- Unified Footer -->
    <div class="disclaimer-footer-outer">
      <div class="footer-links external">
        <div v-if="hasValidConsent && tenantInfo?.showAcceptedDisclaimer">
            <font-awesome-icon
                  :icon="faCheckCircleSolid"
                  width="16px" height="16px"
                  style="font-size: 16px; color: green"
                /><a href="#" v-on:click.prevent="showDisclaimer()">{{ t("message.acceptedDisclaimerLbl") }}</a>
          </div>
        <div v-if="tenantInfo?.dataPrivacyUrl">
          <a target="_blank" :href="tenantInfo.dataPrivacyUrl">{{ t("message.privacyLink") }}</a>
        </div>
        <div v-if="tenantInfo?.imprintUrl">
          <a target="_blank" :href="tenantInfo.imprintUrl">{{ t("message.legalLink") }}</a>
        </div>
      </div>
    </div>

    <div v-show="displayDisclaimer" class="consent-overlay">
        <div class="consent-card">
            <div class="consent-header">
              {{ t("message.acceptedDisclaimerLbl")
              }}<button class="close-btn" @click="closeDisclaimer">
                &times;
              </button>
            </div>
            <div class="consent-body">
              <div class="disclaimer-text">
                <span
                  v-for="(part, index) in combinedDataPrivacyText"
                  :key="index"
                >
                  <template v-if="isPlaceholder(part)">
                    <template v-if="part === '{newLine}'">
                      <br />
                    </template>
                    <template v-else>
                      <a
                        :href="getPlaceholderLink(part)"
                        target="_blank"
                        class="link"
                      >
                        {{ getPlaceholderLabel(part) }}
                      </a>
                    </template>
                  </template>
                  <template v-else>{{ part }}</template>
                </span>
              </div>
            </div>
        </div>
      </div>
  </section>
</template>

<script setup lang="ts">
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Cookies from 'js-cookie';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { LocationQuery, useRoute } from 'vue-router';

import { showErrorMsgToast } from '@/common';
import {
  AiDisclaimerRequestDto,
  DisclaimerTargetResponse,
  DisclaimerTextResponseDto,
  GetDisclaimerRequest,
  ShortUrlEntity,
  ShortUrlRequest,
} from '@/store/models';
import privacyConfirmModule from '@/store/modules/privacyConfirmModule';
import shortUrlModule from '@/store/modules/shortUrlModule';
import tenantModule from '@/store/modules/tenantModule';

import LoadingIndicator from '@/components/LoadingIndicator.vue';
import QrCodeComp from '@/components/QrCodeComp.vue';
import router from '@/router/router';

const props = defineProps(['query']);
const query = ref<LocationQuery | undefined>(props.query);

const step = ref(1);
const showQrCode = ref(false);
const qrCodeLink = ref('');
const tenantIdentifier = ref<string | null>(null);
const language = ref(navigator.language);
const defaultLanguageCode = ref('de');
const disclaimerGuid = ref<string>();
const disclaimerTarget = ref<DisclaimerTargetResponse | null>(null);
const dataPrivacyUrl = ref<string | null>(null);
const redirectUrl = ref('');
const alternateUrl = ref('');
const useDirectUrl = ref(true);
const useWindowOpen = ref(true);
const route = useRoute();
const { t, te, locale } = useI18n();
const showDisclaimerText = ref(false);
const disclaimerData = ref<DisclaimerTextResponseDto>({
  languageCode: '',
  text: '',
  placeholders: [],
  remoteSystemType: '',
  disclaimerType: '',
});
const acceptWhatsappDataPrivacy = ref(true);
const acceptTalentPool = ref(false);
const talentPoolDisclaimer = ref(false); // overwrite this if set by API later
const hideDisclaimerCheckbox = ref(false);
const tenantLogoGuid = ref<string | null>(null);
const customDisclaimer = ref(false);
const contactDisclaimer = ref(false);
const showSubmitBtn = ref(false);
const logoPath = ref('/api/media/v1/logo/');
const loading = ref(false);
const qrImageLoaded = ref(false);
const tenantLogoLoaded = ref(false);
const isAiDisclaimer = query.value?.aiDisclaimer === 'true';
const jobTitleParam = query.value?.title as string | undefined;
const isJobTitleResolved = ref(false);
const remoteSystemType = ref<string | null>(null);
const displayDisclaimer = ref(false);
const hasValidConsent = ref(false);
const tenantLogoLoading = ref(true);

onMounted(async () => {
  locale.value = currentLanguage() as string;
  await onInitialPageLoad(); // Wait for both tenant and disclaimer setup.
});

watchEffect(() => {
  if (
    step.value === 3 &&
    qrCodeLink.value &&
    qrImageLoaded.value &&
    tenantLogoLoaded.value
  ) {
    loading.value = false;
  }
});

const tenantInfo = computed(() => tenantModule.tenantInfoLite);
const enableJobTitle = computed(
  () => tenantInfo.value?.enableDisclaimerJobTitle || isAiDisclaimer,
);
const defaultWhatsAppGreen = 'rgb(69, 189, 89)';

const primaryColor = computed(() => {
  return (
    tenantInfo.value?.primaryColor ||
    tenantInfo.value?.secondaryColor ||
    defaultWhatsAppGreen
  );
});

const tenantLogoGuidComputed = computed(() =>{
  return tenantLogoGuid.value;
});

// const defaultAiText = computed(() => {
//   const raw = tenantInfo.value?.aiDefaultText || '';
//   return raw.replace('{tenantName}', tenantInfo.value?.name || '');
// });

const defaultWhatsappText = computed(() => {
  const raw = tenantInfo.value?.whatsAppDefaultText || '';
  return raw.replace('{tenantName}', tenantInfo.value?.name || '');
});

const colorReady = computed(() => {
  return tenantInfo.value !== null; // resolves as soon as tenant info is loaded
});

const resolvedPrimaryColor = computed(() => {
  if (!colorReady.value) return null;
  return (
    tenantInfo.value?.primaryColor ||
    tenantInfo.value?.secondaryColor ||
    defaultWhatsAppGreen
  );
});

// Final display job title based on full logic
const displayTitle = computed(() => {
  if (jobTitleParam) return jobTitleParam;
  if (isAiDisclaimer) return '';
  if (enableJobTitle.value && disclaimerTarget.value) {
    const titleFromShortUrl =
      disclaimerTarget.value?.shortUrlDto?.disclaimerJobTitle;
    return titleFromShortUrl || defaultWhatsappText.value;
  }
  if(!disclaimerTarget.value){
    return '';
  }
  return defaultWhatsappText.value;
});

async function onInitialPageLoad() {
  loading.value = true;
  try {
    showQrCode.value = false;
    await loadTenantInfoLite();
    if (tenantModule.tenantInfoLite) {
      defaultLanguageCode.value =
        tenantModule.tenantInfoLite.defaultLanguageCode;
      tenantLogoGuid.value = tenantModule.tenantInfoLite.logoGuid || null;
      customDisclaimer.value = tenantModule.tenantInfoLite.customDisclaimer;
    }
    await getDisclaimerTarget();
    if (disclaimerTarget.value) {
      if (disclaimerTarget.value.dataPrivacyUrl) {
        dataPrivacyUrl.value = disclaimerTarget.value.dataPrivacyUrl;
      }
      contactDisclaimer.value =
        disclaimerTarget.value.shortUrlDto.contactDisclaimer;
      talentPoolDisclaimer.value =
        disclaimerTarget.value.shortUrlDto.talentPoolDisclaimer || false;
    }
    if (
      isMobileDevice() &&
      disclaimerTarget.value &&
      disclaimerTarget.value.shortUrlDto &&
      disclaimerTarget.value.shortUrlDto.directAccess
    ) {
      handleDirectAccess(disclaimerTarget.value);
    } else {
      // if (
      //   disclaimerTarget.value &&
      //   disclaimerTarget.value.shortUrlDto &&
      //   !disclaimerTarget.value.shortUrlDto.hideDisclaimer
      // ) {
      //   if (
      //     !isMobileDevice() ||
      //     !customDisclaimer.value ||
      //     (customDisclaimer.value && hideDisclaimerCheckbox.value)
      //   ) {
      showDisclaimerText.value = true;
      //   }
      // }
      showSubmitBtn.value = true;
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function loadTenantInfoLite() {
  try {
    const tenant = tenantModule.tenantInfoLite || null;
    if (!tenant) {
      await tenantModule.loadTenantInfoLite(locale.value);
    }
    if (tenantModule.tenantInfoLite) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const enableWhatsApp = tenantModule.tenantInfoLite.enableWhatsapp;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const readOnlyTenant = tenantModule.tenantInfoLite.readonly;
      const salesTokenSet = query.value?.sid || route.params.sid;
      tenantModule.tenantInfoLite.hideClientDataSecurity;
      if (!enableWhatsApp || (readOnlyTenant && !salesTokenSet)) {
        router.replace({ path: `/${query.value?.id}` }); // redirect to PY Home page via backend call eg. api/dispatch/v1. Replace later with the better approach if any.
        if (
          salesTokenSet &&
          !(await privacyConfirmModule.validateTestUserToken(
            salesTokenSet as string,
          ))
        ) {
          router.replace({ path: `/${query.value?.id}` }); // redirect to PY Home page via backend call eg. api/dispatch/v1. Replace later with the better approach if any.
        }
      }
      dataPrivacyUrl.value = tenantModule.tenantInfoLite.dataPrivacyUrl || null;
      tenantIdentifier.value = tenantModule.tenantInfoLite.identifier || null;
      tenantLogoGuid.value = tenantModule.tenantInfoLite.logoGuid || null;
      remoteSystemType.value =
        tenantModule.tenantInfoLite.remoteSystemType || null;
      hideDisclaimerCheckbox.value =
        tenantModule.tenantInfoLite.hideDisclaimerCheckbox || false;
      if (hideDisclaimerCheckbox.value) {
        acceptWhatsappDataPrivacy.value = true;
        acceptTalentPool.value = true;
      }
    }
  } catch (error) {
    console.log(error);
  }
}

async function loadDisclaimerData() {
  if (!tenantIdentifier.value) return;
  const req: GetDisclaimerRequest = {
    tenantIdentifier: tenantIdentifier.value,
    language: locale.value,
    remoteSystemType: remoteSystemType.value || '',
    disclaimerType: 'WHATSAPP',
    customDisclaimer: customDisclaimer.value,
  };
  disclaimerData.value = await privacyConfirmModule.getDisclaimer(req);
}

function closeConsentCard() {
  //close the overlay and show the disclaimer card again
  step.value = 1;
}

async function onAgreeDisclaimer() {
  loading.value = true;
  qrImageLoaded.value = false;

  try {
    if (isMobileDevice()) {
      if (
        disclaimerTarget.value &&
        disclaimerTarget.value.shortUrlDto?.hideDisclaimer
      ) {
        step.value = 3;
        await getDisclaimerTarget(); // refresh data
        handleDirectAccess(disclaimerTarget.value);
        return;
      }

      // Require checkbox to be ticked
      // if (!acceptWhatsappDataPrivacy.value) {
      //   step.value = 2;
      //   return;
      // }

      step.value = 3;

      if (isAiDisclaimer) {
        await applyAiDisclaimer();
      } else {
        await applyDisclaimer();
      }

      if (disclaimerTarget.value) {
        handleDirectAccess(disclaimerTarget.value);
      } else {
        showErrorMsgToast('Unable to proceed with WhatsApp application.');
      }
    } else {
      const consentValue =
        (acceptWhatsappDataPrivacy.value && !talentPoolDisclaimer.value) ||
        (acceptWhatsappDataPrivacy.value &&
          talentPoolDisclaimer.value &&
          acceptTalentPool.value) || (disclaimerTarget.value && disclaimerTarget.value.shortUrlDto && 
        disclaimerTarget.value.shortUrlDto.hideDisclaimer);
      hasValidConsent.value = consentValue? consentValue:false;
      if (hasValidConsent.value) {
        step.value = 3;
        if (disclaimerTarget.value?.shortUrlDto?.hideDisclaimer) {
          await getDisclaimerTarget();
        } else if (isAiDisclaimer) {
          await applyAiDisclaimer();
        } else {
          await applyDisclaimer();
        }

        if (disclaimerTarget.value) {
          handleDirectAccess(disclaimerTarget.value);
        } else {
          showErrorMsgToast('Unable to proceed with WhatsApp application.');
        }
      }
    }
  } catch (error) {
    console.error(error);
    showErrorMsgToast('Something went wrong during redirection.');
  } finally {
    loading.value = false;
  }
}

async function applyDisclaimer() {
  try {
    const request: ShortUrlRequest = getShortUrlRequest();
    request.dataPrivacyUrl = dataPrivacyUrl.value || '';
    if (talentPoolDisclaimer.value && acceptTalentPool.value) {
      request.acceptTalentPool = true;
    }
    disclaimerTarget.value = await shortUrlModule.doApplyDisclaimer(request);
  } catch (error) {
    console.error('applyDisclaimer error', error);
  }
}

async function applyAiDisclaimer() {
  try {
    setCookie();
    const disclaimerRequest: AiDisclaimerRequestDto = {
      platformType: getPlatform(),
      languageCode: currentLanguage(),
      userAgent: navigator.userAgent,
      additionalParams: JSON.stringify(query.value),
      disclaimerGuid: disclaimerGuid.value ? disclaimerGuid.value : '',
      countryCode: navigator.language,
      channelType: 'WB',
    };
    if (query.value?.utm_source) {
      disclaimerRequest.utm_source =
        (query.value?.utm_source as string) || undefined;
    }

    if (query.value?.utm_medium) {
      disclaimerRequest.utm_medium =
        (query.value?.utm_medium as string) || undefined;
    }

    if (query.value?.utm_campaign) {
      disclaimerRequest.utm_campaign =
        (query.value?.utm_campaign as string) || undefined;
    }

    if (query.value?.utm_content) {
      disclaimerRequest.utm_content =
        (query.value?.utm_content as string) || undefined;
    }
    const aiDisclaimerResponseDto =
      await shortUrlModule.doApplyAiDisclaimer(disclaimerRequest);
    const shorturlDto: ShortUrlEntity = {
      directAccessRedirectUrl: aiDisclaimerResponseDto.redirectUrl,
      directAccessFirstMessageText: aiDisclaimerResponseDto.messageText,
      alternateAccessRedirectUrl: aiDisclaimerResponseDto.redirectUrl,
      guid: '',
      type: '',
      channelType: '',
      translateEnabled: false,
      tenantLanguageCode: '',
      directAccess: false,
      hideDisclaimer: false,
      contactDisclaimer: false,
    };
    const targetResponse: DisclaimerTargetResponse = {
      dataPrivacyUrl: dataPrivacyUrl.value as string,
      shortUrlDto: shorturlDto,
    };
    disclaimerTarget.value = targetResponse;
  } catch (error) {
    console.log(error);
  }
}

async function getDisclaimerTarget() {
  loading.value = true;
  try {
    disclaimerTarget.value =
      await shortUrlModule.doGetDisclaimerTarget(getShortUrlRequest());
    isJobTitleResolved.value = true; // mark job title as loaded
    // console.log(
    //   'disclaimerTarget jobextern key',
    //   disclaimerTarget.value.shortUrlDto.jobSlug,
    // );
  } catch (error) {
    console.error('getDisclaimerTarget error', error);
    showErrorMsgToast('Unable to fetch disclaimer details.');
  } finally {
    loading.value = false;
  }
}

// const showTitleBlock = computed(() => {
//   return isJobTitleResolved.value && Boolean(displayTitle.value);
// });

function handleDirectAccess(target: DisclaimerTargetResponse) {
  const dto = target.shortUrlDto;
  if (
    !dto ||
    !dto.directAccessRedirectUrl ||
    !dto.alternateAccessRedirectUrl ||
    !dto.directAccessFirstMessageText
  ) {
    console.warn('Missing required redirect fields in shortUrlDto');
    return;
  }

  redirectUrl.value =
    dto.directAccessRedirectUrl + dto.directAccessFirstMessageText;
  alternateUrl.value =
    dto.alternateAccessRedirectUrl + dto.directAccessFirstMessageText;
  qrCodeLink.value = redirectUrl.value;

  qrImageLoaded.value = false; // reset before image loads
  step.value = 3; // show the wrapper

  if (isMobileDevice()) {
    window.location.href = redirectUrl.value;
  }
}

function currentLanguage(): string {
  if (language.value && language.value.length > 2) {
    return language.value.substring(0, 2);
  }

  return language.value;
}

function handleRedirectFromBtn() {
  const url = useDirectUrl.value ? redirectUrl.value : alternateUrl.value;
  useWindowOpen.value
    ? window.open(url, '_system')
    : (window.location.href = url);
  useWindowOpen.value = !useWindowOpen.value;
}

function getShortUrlRequest(): ShortUrlRequest {
  setCookie();
  const guidParam =
    (query.value?.id as string) || (query.value?.param as string);

  const request: ShortUrlRequest = {
    guid: guidParam,
    externalCall:
      query.value && query.value?.extcall
        ? (query.value?.extcall as unknown as boolean)
        : false,
    apiCall:
      query.value && query.value?.apicall
        ? (query.value?.apicall as unknown as boolean)
        : false,
    jkey:
      query.value && query.value?.jkey
        ? (query.value?.jkey as string)
        : undefined,
    languageCode: currentLanguage(),
    countryCode: navigator.language,
    additionalParams: JSON.stringify(query.value),
    disclaimerGuid: disclaimerGuid.value,
    platformType: getPlatform(),
    directRedirect:
      disclaimerTarget.value && disclaimerTarget.value.shortUrlDto
        ? disclaimerTarget.value.shortUrlDto.hideDisclaimer
        : false,
    aiDisclaimerTarget: isAiDisclaimer,
  };

  if (query.value?.utm_source) {
    request.utm_source = (query.value?.utm_source as string) || undefined;
  }

  if (query.value?.utm_medium) {
    request.utm_medium = (query.value?.utm_medium as string) || undefined;
  }

  if (query.value?.utm_campaign) {
    request.utm_campaign = (query.value?.utm_campaign as string) || undefined;
  }

  if (query.value?.utm_content) {
    request.utm_content = (query.value?.utm_content as string) || undefined;
  }

  if (query.value?.title) {
    request.title = (query.value?.title as string) || undefined;
  }
  if (query.value?.company) {
    request.company = (query.value?.company as string) || undefined;
  }

  if (query.value?.externalJobId) {
    request.externalJobId = (query.value?.externalJobId as string) || undefined;
  }

  request.channelType = 'WB';
  request.userAgent = navigator.userAgent;
  return request;
}

function getPlatform(): string {
  const ua = navigator.userAgent.toLowerCase();

  if (/android/.test(ua)) return 'ANDROID';
  if (/iphone|ipad|ipod/.test(ua)) return 'IOS';

  if (/chrome/.test(ua) && !/edg/.test(ua)) return 'CHROME';
  if (/firefox/.test(ua)) return 'FIREFOX';
  if (/edg/.test(ua)) return 'CHROME'; // treat Edge as Chrome (Chromium-based)

  return 'DESKTOP'; // fallback for anything not mobile or recognized
}

function setCookie(): void {
  disclaimerGuid.value = Cookies.get('disclaimerGuid') ?? generateGuid();
  Cookies.set('disclaimerGuid', disclaimerGuid.value);
}

function generateGuid(): string {
  return (
    Math.random().toString(36).substring(2, 6) +
    Math.random().toString(36).substring(2, 6)
  ).toUpperCase();
}

function isMobileDevice(): boolean {
  return /Mobi|Android/i.test(navigator.userAgent);
}

const tenantLogoLoadedComputed = computed(() => {
    return tenantLogoLoaded.value;
});

const tenantLogoLoadingComputed = computed(() => {
    return tenantLogoLoading.value;
});

function handleImageLoad(){
  tenantLogoLoading.value = false;
    tenantLogoLoaded.value = true;
}

function handleImageError(event: Event) {
  const target = event.target as HTMLImageElement;
  target.style.display = 'none';
  tenantLogoLoaded.value = false;
  tenantLogoLoading.value=false;
  // tenantLogoGuid.value = null; // force fallback to tenant name
}

function isPlaceholder(part: string): boolean {
  return part.startsWith('{') && part.endsWith('}');
}

function getPlaceholderLink(placeholder: string): string {
  const key = placeholder.slice(1, -1);
  return (
    disclaimerData.value.placeholders.find((p) => p.placeholderKey === key)
      ?.url ?? '#'
  );
}

function getPlaceholderLabel(placeholder: string): string {
  const key = placeholder.slice(1, -1);
  return (
    disclaimerData.value.placeholders.find((p) => p.placeholderKey === key)
      ?.labelText ?? placeholder
  );
}

const combinedDataPrivacyText = computed(() => {
  const text = disclaimerData.value.text;
  return text ? text.split(/(\{[a-zA-Z0-9_]+\})/) : [];
});

// function onTenantLogoLoaded() {
//   tenantLogoLoaded.value = true;
//   checkStep3AssetsReady();
// }

// function onTenantLogoError(event: Event) {
//   const target = event.target as HTMLImageElement;
//   target.style.display = 'none';
//   tenantLogoLoaded.value = false; // even on error, we let UI proceed
//   tenantLogoGuid.value = null;
//   checkStep3AssetsReady();
// }

function onQrCodeReady() {
  qrImageLoaded.value = true;
  checkStep3AssetsReady();
}

function checkStep3AssetsReady() {
  if (qrImageLoaded.value && tenantLogoLoaded.value) {
    loading.value = false;
  }
}

function getDisplayText(key: string) {
  const aiKey = key + '_ai';
  const mobileKey = key + '_mobile';
  const mobileAiKey = key + '_ai_mobile';

  if (isMobileDevice()) {
    if (isAiDisclaimer) {
      if (te(mobileAiKey)) {
        return t(mobileAiKey);
      } else if (te(aiKey)) {
        return t(aiKey);
      }
    }
    if (te(mobileKey)) {
      return t(mobileKey);
    }
  }
  if (isAiDisclaimer) {
    if (te(aiKey)) {
      return t(aiKey);
    }
  }

  return t(key);
}
// Handles the click on the WhatsApp apply button (step 1)
async function handleRedirectToDisclaimer() {
  loading.value = true;
  try {
    if (showDisclaimerText.value) {
      await loadDisclaimerData();
      step.value = 2;
    }
  } catch (error) {
    console.error('Error in handleRedirectToDisclaimer:', error);
    showErrorMsgToast('Something went wrong. Please try again.');
  } finally {
    loading.value = false;
  }
}

function showDisclaimer(){
  displayDisclaimer.value = true
}

function closeDisclaimer(){
  displayDisclaimer.value = false;
}
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

/* Optional: smoother transitions when switching steps */
.blurred {
  filter: blur(4px);
  opacity: 0.6;
  pointer-events: none;
  user-select: none;
  transition:
    filter 0.3s ease,
    opacity 0.3s ease;
}

.button-footer-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.card-base {
  width: 100%;
  max-width: 350px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 10px;
  /* padding: 1.5rem; */
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  text-align: center;
  font-family: "Inter", sans-serif;
  background-color: rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  z-index: 1;
  transition: all 0.3s ease;
}

.disclaimer-card {
  background-color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease-in-out;
  /* min-height: 500px; */
  /* or whatever suits your content, prevents jump */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.disclaimer-text {
  font-size: 13px;
  color: #4a4a4a;
  line-height: 1.5;
  margin-bottom: 0.1rem;
  text-align: left;
}

.description {
  width: 100%;
  text-align: center;
  color: #86868b;
  font-size: 15px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19px;
  word-wrap: break-word;
}

.disclaimer-text .link {
  color: #047abf;
  text-decoration: underline;
  cursor: pointer;
}

.consent-card {
  background: #f2f2f2;
  padding: 1.5rem;
  max-width: 360px;
  border-radius: 10px;
  overflow-y: auto;
  margin: auto 0;
  font-family: "Inter", sans-serif;
  width:350px;
}

/* .consent-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  box-sizing: border-box;
} */
.consent-overlay {
  position: fixed;        /* keep it off the document flow */
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  overflow-y: auto;       /* overlay scrolls instead of the page */
  -webkit-overflow-scrolling: touch;
  background: rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(5px);
}

body.consent-open {
  overflow: hidden;       /* optional: add/remove when overlay is shown */
}

.consent-card {
  margin: auto; /* keeps the card centered while allowing overlay scrolling */
}  

.disclaimer-container {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  padding: 2rem 1rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  position: relative;
  box-sizing: border-box;
}

.disclaimer-inner-container{
  width: 350px;
}

.success-card {
  background: white;
}

.steps {
  display: flex;
  flex-direction: column;
  /* No gap: the spacing lives in .step-text so the connector can span it */
  gap: 0;
  align-items: flex-start;
}

.card-base .steps {
    margin-top: -24px;
}

.step-item {
  display: flex;
  /* stretch: lets the icon column take the full height of the row */
  align-items: stretch;
  gap: 15px;
}

.step-item:not(:last-child) .step-text {
  padding-bottom: 8px;
}

.icon-box {
  width: 24px;
  height: 24px;
  padding: 10px;
  /* border: 1px solid #ececec;
  border-radius: 50%; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-box > svg {
  color: #000000;
}

.icon-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}

.vertical-line {
  width: 1px;
  /* fills the rest of the row so the line always reaches the next icon */
  flex: 1;
  background-color: #ececec;
}

.step-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

.step-text h3,
.step-text p {
  font-size: 15px;
  line-height: 19px;
  margin: 0;
  word-wrap: break-word;
}

.step-text h3 {
  font-weight: 590;
  color: #1d1d1f;
}

.step-text p {
  font-weight: 500;
  color: #86868b;
}

.logo-wrapper {
  /* min-height: 80px; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.75rem;
  margin-top: 1rem;
}

.logo-wrapper img {
  max-width: 180px;
  max-height: 120px;
  object-fit: contain;
  display: none;
}

.tenant-logo-img,
.tenant-name-fallback {
  max-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tenant-logo-img{
  display:none;
}

.header-text {
  margin: 0;
  padding-top: 0.25rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem; /* Ensures spacing between subtitle and title is consistent */
}

.logo-wrapper:has(.tenant-name-fallback) {
  margin-bottom: 0.5rem;
}

.primary-btn {
  width: 100%;
  max-width: 350px;
  padding: 0.75rem 1.5rem;
  border-radius: 20px;
  border: none;
  color: white;
  font-size: 15px;
  font-weight: 590;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  margin: 0 auto;
  background-color: #f2f2f2;
  /* skin tone */
}

.layout-title {
  height: auto;
  line-height: 24px;
  font-size: 20px;
  font-weight: 590;
  font-family: "Inter", sans-serif;
  word-break: break-word;
  color: #1d1d1f;
  margin-top: 0;
}

.layout-subtitle {
  height: 19px;
  line-height: 19px;
  font-size: 15px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  color: #333;
  word-break: break-word;
  margin-bottom: 0.1rem;
}

.qr-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  width: 100%;

}

.qr-box {
  width: 350px;
  max-width: 350px;
  aspect-ratio: 1 / 1;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid #ececec;
  background: #f2f2f2;
}

.qr-instruction {
  font-size: 14px;
  color: #666;
  margin-bottom: 1rem;
  text-align: center;
}

.footer-links {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 19px;
  color: #86868b;
  text-align: center;
  gap: 8px;
  font-family: "Inter", sans-serif;
}

.footer-links a {
  color: #86868b;
  text-decoration: underline;
  box-sizing: border-box;
}

.disclaimer-footer-outer {
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-bottom: 2rem;
  margin-top: -1rem;
}

.footer-links.external {
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  color: #86868b;
  text-align: center;
}

.footer-links.external a {
  color: #86868b;
  text-decoration: underline;
}

.skeleton.skeleton-logo {
  width: 180px;
  height: 80px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin: 0 auto;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton.skeleton-title {
  width: 60%;
  height: 24px;
  margin: 12px auto;
  background-color: #e0e0e0;
  border-radius: 6px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton.skeleton-subtitle {
  width: 50%;
  height: 19px;
  margin: 8px auto;
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton.skeleton-button {
  height: 40px;
  max-width: 350px;
  width: 100%;
  background-color: #e0e0e0;
  margin: 1rem auto;
  border-radius: 20px;
}

.skeleton.skeleton-consent-line {
  height: 16px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin: 6px 0;
}

.skeleton-qr-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  animation: pulse 1.5s infinite ease-in-out;
  border-radius: 10px;
  top: 0;
  left: 0;
  z-index: 2;
}

.skeleton-disclaimer-block {
  width: 100%;
  max-width: 320px;
  height: 120px;
  background-color: #e0e0e0;
  border-radius: 6px;
  margin: 0 auto;
  animation: pulse 1.5s infinite ease-in-out;
}

.layout-title,
.skeleton.skeleton-title {
  height: auto;
  line-height: 24px;
}

.layout-subtitle,
.skeleton.skeleton-subtitle {
  height: 19px;
  line-height: 19px;
}

.tenant-name-fallback {
  font-size: 18px;
  font-weight: 590;
  color: #333;
  text-align: center;
  max-width: 250px;
  /* min-height: 80px; */
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 0;
  font-family: "Inter", sans-serif;
}

/* Add spacing control to .header-text to stabilize height */
.header-text {
  min-height: 60px;
  padding-bottom: 0.5rem;
}

/* DEVICE SPECIFIC STYLES */
@media (min-width: 768px) {
  .disclaimer-container {
    padding: 2rem 1rem;
  }

  .consent-card {
    max-width: 800px;
    padding: 1rem;
  }

  .card-base {
    max-width: 100%;
    border-radius: 0;
    /* padding: 1rem; */
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}

.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  background: lightgray;
  border: none;
  font-size: 20px;
  cursor: pointer;
  border-radius: 15px;
}

.consent-header {
  position: relative;
  padding-bottom: 10px;
}

.consent-body {
  padding-bottom: 10px;
}

.is-loaded{
  display: block !important;
}
</style>
